exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* Modal-specific styles */\n.modal-container[data-v-309cd96e] {\n  scroll-behavior: smooth;\n  scrollbar-width: thin;\n  --v-scrollbar-offset: 10px;\n  padding: 0.5rem 0.7rem !important;\n}\n\n/* Adjust spacing for modal context */\n.edit-entry-component[data-v-309cd96e] {\n  min-height: 100%;\n}\n.modal-container label[data-v-309cd96e] {\n  margin-bottom: 0 !important;\n}\n\n/* When used in modal, reduce some padding */\n.modal-container .py-2[data-v-309cd96e] {\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n}\n", ""]);

// exports
